// 채널(영업자) 카테고리 — 영업자가 채널관리에서 최대 2개까지 선택. 메인 페이지 상단 필터도 이 목록을 그대로 쓴다.
export const CHANNEL_CATEGORIES = ['패션', '뷰티', '식품', '리빙', '생활용품', '잡화', '기타'] as const;
export type ChannelCategory = typeof CHANNEL_CATEGORIES[number];
export function isChannelCategory(v: string): v is ChannelCategory {
  return (CHANNEL_CATEGORIES as readonly string[]).includes(v);
}
